import { useState } from "react";
import { toast } from "sonner";
import { CheckCheck, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const AcceptAllButton = ({ kit, reload, disabled }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const rows = (kit.page_check?.pages || []).filter((r) => r.status === "light" && r.acceptable);
  if (!rows.length) return null;
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await http.post(`/kits/${kit.id}/page-accept-all`);
      toast.success(`Accepted ${data.accepted} page(s) as is`);
      await reload();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid="accept-all-button" disabled={disabled || busy} onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-sm border border-sky-200 bg-sky-50 px-4 py-2 text-sm font-medium text-sky-800 hover:bg-sky-100 transition-colors disabled:opacity-40">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <CheckCheck size={15} />} Accept all light pages ({rows.length})
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="accept-all-dialog" className="bg-white text-[#2B2A26]">
          <AlertDialogHeader>
            <AlertDialogTitle>Accept {rows.length} page(s) as is?</AlertDialogTitle>
            <AlertDialogDescription>{rows.map((r) => `p.${r.n} ${r.label} (${Math.round(r.fill * 100)}%)`).join(" · ")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="accept-all-cancel" className="bg-white">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="accept-all-confirm" onClick={go} className="bg-sky-700 text-white hover:bg-sky-800">Accept all</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
